var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-avatar',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"background-color":"transparent"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',[_vm._v("Loading ...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }